import Cookie from 'js-cookie';
import axios from 'axios';
// import { Env } from '@stencil/core';

async function logout(env) {

	const BTSESSION = Cookie.get("BTSESSION");

	const logoutApi = `${env}/service/user/xml/logout`;

	if (!BTSESSION) return null

	if (BTSESSION && typeof BTSESSION != 'undefined') {
		try {
			const { data } = await axios.get(
				logoutApi,
			{
				headers: {
					'Accept': 'application/json',
					'Cookie': 'BTSESSION=' + BTSESSION,
					'X-BrightTALK-access': 'niHeeF1ao2',
					'Content-Type': 'application/json',
					'BrightTALK-API-Client': 'wordpress'
				},
				withCredentials: true
			}
			);
			console.log("success");
			console.log(data);
			if (data?.state === 'processed') {
				Cookie.remove('BTSESSION')
				Cookie.remove('btsession_user_id')
				window.location.href = env
			}
		} catch (error) {
			console.log("error");
			console.log(error);
		}
	}

}

export default logout